let pdfMakeInstance = null;

export const getPdfMake = async () => {
    if (pdfMakeInstance) return pdfMakeInstance;
    console.debug("---------------------- Caching pdfmake and Roboto Fonts -----------------------")
    const [{ default: pdfMake }, pdfFonts] = await Promise.all([
        import("pdfmake/build/pdfmake"),
        import("pdfmake/build/vfs_fonts")
    ]);

    pdfMake.addVirtualFileSystem(pdfFonts.default || pdfFonts);

    pdfMakeInstance = pdfMake;

    return pdfMakeInstance;
};
